import gql from 'graphql-tag'

export default gql`mutation ycmdChatRoomLeave($room_id: ID!) {
    ycmdChatRoomLeave(room_id: $room_id) 
    {
        status
	  }
}`
